module.exports = {
      id: "spiritual-usage",
      viewBox: "0 0 27.233 28.49",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#spiritual",
      toString: function () {
        return this.url;
      }
    }